import { getActionsByUserType } from '../config/actions';

export const useQuickActions = (purchaseCallback = null) => {
  const userType = localStorage.getItem('user_type');
  const uid = localStorage.getItem('uid');

  return getActionsByUserType(userType, uid, purchaseCallback);
};
